module.exports = __webpack_public_path__ + "img/gh-305em-04.prt.f3dafd9d.jpg";